import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/home'),
      meta: {
        nav: '',
        nokeep: false,
        activeName: '/home',
        hideTop: true
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/pages/home'),
      meta: {
        nav: '',
        nokeep: false,
        activeName: '/home',
        hideTop: true
      }
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('@/pages/activity'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/detail',
        activeNameSub: '/activity',
        whiteTitle: true
      }
    },
    {
      path: '/activityExchange',
      name: 'activityExchange',
      component: () => import('@/pages/activity/exchange'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/detail',
        activeNameSub: '/activity',
        whiteTitle: true
      }
    },
    {
      path: '/activityGreen',
      name: 'activityGreen',
      component: () => import('@/pages/activity/green'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/detail',
        activeNameSub: '/activity',
        whiteTitle: true
      }
    },
    {
      path: '/hostForum',
      name: 'hostForum',
      component: () => import('@/pages/hostForum'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/detail',
        activeNameSub: '/hostForum'
      }
    },
    {
      path: '/liveHostDetail',
      name: 'liveHostDetail',
      component: () => import('@/pages/hostForum'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/live',
      }
    },
    {
      path: '/jianjieForum',
      name: 'jianjieForum',
      component: () => import('@/pages/jianjieForum'),
      meta: {
        nav: '',
        nokeep: false,
        activeName: '/detail',
        activeNameSub: '/jianjieForum'
      }
    },
    {
      path: '/jianjieForumDetail',
      name: 'jianjieForumDetail',
      component: () => import('@/pages/jianjieForum/detail'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/detail',
        activeNameSub: '/jianjieForum'
      }
    },
    {
      path: '/liveJianjieDetail',
      name: 'liveJianjieDetail',
      component: () => import('@/pages/jianjieForum/detail'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/live',
      }
    },
    {
      path: '/technology',
      name: 'technology',
      component: () => import('@/pages/technology'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/detail',
        activeNameSub: '/technology'
      }
    },
    {
      path: '/cooperattion',
      name: 'cooperattion',
      component: () => import('@/pages/cooperattion'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/cooperattion',
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/pages/contact'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/contact',
      }
    },
    {
      path: '/media',
      name: 'media',
      component: () => import('@/pages/media'),
      meta: {
        nav: '',
        nokeep: false,
        activeName: '/media',
      }
    },
    {
      path: '/live',
      name: 'live',
      component: () => import('@/pages/live'),
      meta: {
        nav: '',
        nokeep: false,
        activeName: '/live',
      }
    },
    {
      path: '/mediaDetail',
      name: 'mediaDetail',
      component: () => import('@/pages/media/detail'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/media',
        activeNameSub: '/mediaDetail'
      }
    },
    {
      path: '/wonderful',
      name: 'wonderful',
      component: () => import('@/pages/media/detail'),
      meta: {
        nav: '',
        nokeep: true,
        activeName: '/live',
      }
    },
    {
      path: '/join',
      name: 'join',
      component: () => import('@/pages/join/index'),
      meta: {
        nav: '',
        nokeep: true
      }
    },
  ]
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js